import { orderBy } from "lodash";
import { errorLog } from "../../../logger";
import { defaultAllDocs } from "../constants";
const removeTrailingSlash = (path) => {
    return path.endsWith("/") ? path.substring(0, path.length - 1) : path;
};
const endpointDirNameToS3DirName = (dirName) => {
    switch (dirName) {
        case "FartherRecords":
            return "Farther%20Records";
        case "AlternativeInvestments":
            return "Alternative%20Investments";
        case "BusinessOwnership":
            return "Business%20Ownership";
        case "Education":
            return "Education";
        case "EmployerAgreements":
            return "Employer%20Agreements";
        case "EstatePlanning":
            return "Estate%20Planning";
        case "InsurancePolicies":
            return "Insurance%20Policies";
        case "Leases":
            return "Leases";
        case "Other":
            return "Other";
        case "PropertyOwnership":
            return "Property%20Ownership";
        case "Statements":
            return "Statements";
        case "Taxes":
            return "Taxes";
        case "Trusts":
            return "Trusts";
        case "Vehicles":
            return "Vehicles";
        default:
            errorLog("Unexpected directory name", dirName);
            return "Other";
    }
};
const PATH_MID_DIR_LEVEL_START_POINT = 3; //start 4 levels deep (0 based), (BE brings back Doc Center base dirs which start at 3 levels deep)
export const getEffectiveDocuments = (documents) => {
    if (documents === null || documents === undefined) {
        return null;
    }
    // "FartherRecords" comes in but want: "Farther%20Records" bc its the actual dir name in s3
    const allDocs = { ...defaultAllDocs };
    Object.entries(documents).forEach(([key]) => {
        const baseDir = key;
        const pathPartObjs = documents[baseDir]; // baseDir: EndpointBaseDirectory
        if (pathPartObjs) {
            // want to add missing directory levels: these will never be the base dir or leaf nodes = files
            const addedDirs = [];
            const currentDirectories = {};
            pathPartObjs.forEach((curr) => {
                const pathPartObj = curr;
                if (pathPartObj.currentDirectory !== null) {
                    currentDirectories[pathPartObj.currentDirectory] = 1; // add to seen currentDirectories
                }
                // look at its path and see if we need to add any middle dirs that BE did not send us
                const pathPartsList = removeTrailingSlash(pathPartObj.path).split("/");
                const pathPartsListLength = pathPartObj.fileName !== null
                    ? pathPartsList.length - 1
                    : pathPartsList.length;
                let path = `${pathPartsList[0] ?? ""}/${pathPartsList[1] ?? ""}/${pathPartsList[2] ?? ""}/`;
                // this loop will never reach a file (factored in -> pathPartsListLength)
                for (let l = PATH_MID_DIR_LEVEL_START_POINT; l < pathPartsListLength; l++) {
                    const curPathPart = pathPartsList[l] ?? "";
                    path = `${path}${curPathPart}/`;
                    if (currentDirectories[curPathPart] == null) {
                        // middle dir DNE: need to add
                        currentDirectories[curPathPart] = 1; // add to seen currentDirectories
                        addedDirs.push({
                            altInvestmentAssetName: pathPartObj.altInvestmentAssetName,
                            baseDirectory: pathPartObj.baseDirectory,
                            currentDirectory: curPathPart,
                            date: null,
                            fileName: null,
                            fileType: null,
                            parentDirectory: pathPartsList[l - 1] ?? "",
                            path,
                            size: pathPartObj.size,
                        });
                    }
                }
            });
            // so when iterating can look at children before parents
            const addedDirsOrderedByDirLevelDesc = orderBy(addedDirs, (dir) => dir.path.split("/").length, ["desc"]);
            // need to grab the most historic date from the pathPart's children and set as cur dir's date since date is null
            const allPathPartObjs = [...pathPartObjs];
            addedDirsOrderedByDirLevelDesc.forEach((element) => {
                const addedPathPart = element;
                const childPathPartsOfAddedPathPart = allPathPartObjs.filter((pathPartObj) => pathPartObj.parentDirectory === addedPathPart.currentDirectory);
                if (childPathPartsOfAddedPathPart.length > 0) {
                    const orderedChildPathPartsOfAddedPathPartAsc = orderBy(childPathPartsOfAddedPathPart, ["date"], ["asc"]);
                    if (orderedChildPathPartsOfAddedPathPartAsc[0]) {
                        addedPathPart.date =
                            orderedChildPathPartsOfAddedPathPartAsc[0].date;
                    }
                }
                allPathPartObjs.push(addedPathPart);
            });
            allDocs[endpointDirNameToS3DirName(key)] = allPathPartObjs;
        }
    });
    return allDocs;
};
//# sourceMappingURL=getEffectiveDocuments.js.map